const AddressesActionTypes = {
    START_GET_ADDRESSES_SUBSCRIPTIONS: 'START_GET_ADDRESSES_SUBSCRIPTIONS',
    SUCCESS_GET_ADDRESSES_SUBSCRIPTIONS: 'SUCCESS_GET_ADDRESSES_SUBSCRIPTIONS',
    FINISH_GET_ADDRESSES_SUBSCRIPTIONS: 'FINISH_GET_ADDRESSES_SUBSCRIPTIONS',
    FAILURE_GET_ADDRESSES_SUBSCRIPTIONS: 'FAILURE_GET_ADDRESSES_SUBSCRIPTIONS',
    START_BUY_ADDRESS_SUBSCRIPTION: 'START_BUY_ADDRESS_SUBSCRIPTION',
    SUCCESS_BUY_ADDRESS_SUBSCRIPTION: 'SUCCESS_BUY_ADDRESS_SUBSCRIPTION',
    FINISH_BUY_ADDRESS_SUBSCRIPTION: 'FINISH_BUY_ADDRESS_SUBSCRIPTION',
    FAILURE_BUY_ADDRESS_SUBSCRIPTION: 'FAILURE_BUY_ADDRESS_SUBSCRIPTION',
    START_CHANGE_SHIPPING_ADDRESS: 'START_CHANGE_SHIPPING_ADDRESS',
    SUCCESS_CHANGE_SHIPPING_ADDRESS: 'SUCCESS_CHANGE_SHIPPING_ADDRESS',
    FINISH_CHANGE_SHIPPING_ADDRESS: 'FINISH_CHANGE_SHIPPING_ADDRESS',
    FAILURE_CHANGE_SHIPPING_ADDRESS: 'FAILURE_CHANGE_SHIPPING_ADDRESS',

    START_VERIFY_PRIMARY_ADDRESS: 'START_VERIFY_PRIMARY_ADDRESS',
    SUCCESS_VERIFY_PRIMARY_ADDRESS: 'SUCCESS_VERIFY_PRIMARY_ADDRESS',
    FINISH_VERIFY_PRIMARY_ADDRESS: 'FINISH_VERIFY_PRIMARY_ADDRESS',
    FAILURE_VERIFY_PRIMARY_ADDRESS: 'FAILURE_VERIFY_PRIMARY_ADDRESS',
}

export default AddressesActionTypes
